// src/services/aiCapabilitiesApi.js
import apiService from './apiService';

const aiCapabilitiesApi = {
  list: () => apiService.get('/ai-capabilities'),
  create: (data) => apiService.post('/ai-capabilities', data),
  update: (id, data) => apiService.put(`/ai-capabilities/${id}`, data),
  remove: (id) => apiService.delete(`/ai-capabilities/${id}`),
};

export default aiCapabilitiesApi;
